import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams, useSearchParams } from "react-router-dom"
import AttachDetail from "customerAttachments/components/AttachmentDetail"
import { IdCards, TransferAttachMapping } from "customerAttachments/constants"
import { useModal } from "customerAttachments/contexts/ModalProvider"
import { TransferAttachType } from "customerAttachments/types"
import { useNavigation } from "modules/navigation"

import useGetTransferAttachment from "./hooks/useGetTransferAttachment"
import useUploadTransferAttachments from "./hooks/useUploadTransferAttachments"

type UploadFile = {
  FileName: string
  Base64: string
}

const TransferAttachDetail = () => {
  const { transferId = "" } = useParams<{ transferId: string }>()
  const [searchParams] = useSearchParams()
  const attachType = searchParams.get("type") as TransferAttachType
  const actionStatus = searchParams.get("action")
  const { data: attachInfo, isLoading, isSuccess } = useGetTransferAttachment({ transferId, attachType })
  const { mutate, isLoading: isUploading } = useUploadTransferAttachments({ transferId, attachType })
  const { navigateTo } = useNavigation()
  const { openModal } = useModal()
  const { t } = useTranslation(["sales", "label"])
  const isIdCard = attachType && IdCards.includes(attachType)
  const attachTypeText = (attachType && TransferAttachMapping[attachType]?.Text) || ""
  const [files, setFiles] = useState<Array<UploadFile | null>>(Array(isIdCard ? 2 : 1).fill(null))

  useEffect(() => {
    if (!actionStatus && isSuccess) {
      searchParams.set("action", attachInfo?.FileUrl ? "preview" : "edit")
      navigateTo(`/transfer/${transferId}/attachment?${searchParams.toString()}`)
    }
  }, [attachInfo?.FileUrl, isSuccess, actionStatus, searchParams, transferId, navigateTo])

  const goBack = () => navigateTo(`/transfer/${transferId}`)

  const handleSubmit = async (files: UploadFile[]) => {
    try {
      await mutate({ Files: files })
      setTimeout(() => {
        openModal({
          title: t("order.checklist_upload_success"),
          content: t("customer_attachments.upload_success"),
          showCancel: false,
          onConfirm: goBack,
          onCancel: goBack,
        })
      }, 300)
    } catch (error) {
      openModal({
        title: t("order.checklist_msg_upload_fail"),
        content: t("customer_attachments.upload_failed"),
        showCancel: false,
        confirmButtonText: t("label:okay"),
      })
    }
  }

  return (
    <AttachDetail
      attachType={attachType}
      attachTypeText={attachTypeText}
      goBack={goBack}
      url={attachInfo?.FileUrl}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      setFiles={setFiles}
      files={files}
      isUploading={isUploading}
    />
  )
}

export default TransferAttachDetail
